import React from 'react';
import { BaasicInput, BaasicConfirmModal, BaasicCheckbox } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { renderIf } from 'core/utils';

function TableFilterNumericTemplate({ t, ...props }) {
	const {
		onClose,
		onClear,
		onApply,
		onRemove,
		position: { top, left, tableWrap, startLeftValue },
		form,
		title,
		warningModal,
		columnFilter,
		onCheck,
		isFoListFilter,
	} = props;

	var hasErrorsChecked = false;
	if (form.$('filterErrorOrders').value) {
		hasErrorsChecked = true;
	} else {
		hasErrorsChecked = false;
	}
	return (
		<form
			className={startLeftValue < tableWrap ? 'table-filter' : 'table-filter arrow-right'}
			style={{ top: top, left: left }}
			onSubmit={form.onSubmit}
		>
			<div className="row padd--bottom--sml">
				<div className="col col-sml-10">
					<h4 className="pull padd--top--tny">{t(title)}</h4>
				</div>
			</div>
			<button
				className="btn btn--med btn--ghost ReactModal__close react-filter-box-close"
				onClick={onClose}
				type="button"
			>
				<i className="fa fa-times"></i>
			</button>
			<div className="clearfix"></div>
			{renderIf(!form.$('numberRangeStart').value && !form.$('numberRangeEnd').value)(
				<BaasicInput field={form.$('specificNumber')} />
			)}
			{renderIf(
				!form.$('numberRangeStart').value && !form.$('numberRangeEnd').value && !form.$('specificNumber').value
			)(<div className="spc--bottom--sml">{t('FILTER.NUMBEROR')}</div>)}
			{renderIf(!form.$('specificNumber').value)(
				<section>
					<BaasicInput field={form.$('numberRangeStart')} />
					<BaasicInput field={form.$('numberRangeEnd')} />
				</section>
			)}
			{renderIf(isFoListFilter)(
				<section>
					<BaasicCheckbox
						id={'filterErrorOrders'}
						onChange={event => onCheck(event, form.$('filterErrorOrders'))}
						checked={form.$('filterErrorOrders').value === '' ? false : form.$('filterErrorOrders').value} // Convert to bool if empty
						label="FILTER.HASERRORS"
					/>
				</section>
			)}
			<div className="separator--primary spc--bottom--xsml spc--top--xsml"></div>
			<div className="clearfix spc--bottom--sml">
				<button
					disabled={
						form.$('specificNumber').value.length == 0 &&
						(form.$('numberRangeStart').value == '' || form.$('numberRangeEnd').value == '') &&
						!hasErrorsChecked
					}
					className="btn btn--med btn--tertiary table-filter__fullwidth"
					type="submit"
					onClick={onApply}
				>
					{t('FILTER.APPLY')}
				</button>
			</div>
			<button disabled={!columnFilter} className="btn btn--med btn--secondary pull" onClick={onRemove}>
				{t('FILTER.REMOVE')}
			</button>
			<button
				disabled={
					form.$('specificNumber').value.length == 0 &&
					(form.$('numberRangeStart').value == '' || form.$('numberRangeEnd').value == '') &&
					!hasErrorsChecked
				}
				className="btn btn--med btn--primary push"
				onClick={onClear}
			>
				{t('FILTER.CLEAR')}
			</button>
			<div className="clearfix"></div>
			<BaasicConfirmModal modalParams={warningModal} />
		</form>
	);
}

export default defaultTemplate(TableFilterNumericTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/table/TableFilterNumericTemplate.jsx